import React, {Component, createRef} from "react";
import DataTable from './TableBase';
import {IconButton} from "@material-ui/core";
import {withRouter} from "react-router-dom";
import Swal from "sweetalert2";
import {apiCall} from "../../helpers/MainHelper";
import withPermissions from "../WithPermissions";
import ReactDOMServer from "react-dom/server";
import ReactLoading from "react-loading";
class ExpensesTable extends Component{

    constructor(props) {
        super(props);
        this.tableRef = createRef();
        this.state = {
            pending:true
        }

    }
    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };

    handleDelete = async (expenseID) => {
        const result = await Swal.fire({
            title: 'Silmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, sil!',
            cancelButtonText: 'Hayır, iptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

                try {
                    await apiCall('business/expense/delete/'+expenseID,'delete',null);
                    await this.triggerFetch();
                    return true;
                } catch (error) {
                    return false;
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed) {
            if (result.value) {
                Swal.fire(
                    'Silindi!',
                    'Gider başarıyla silindi.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Hata!',
                    'Silme işlemi başarısız oldu.',
                    'error'
                );
            }
        }
    }
    handleExpenseDetail = (expenseID) => {
        this.props.history.push(`/expense-detail/${expenseID}`);
    }
    render() {
        const {pending} = this.state;
        const {userPermissions} = this.props;
        const userHasViewExpensePermission = userPermissions.includes('view expense');
        const userHasDeleteExpensePermission = userPermissions.includes('delete expense');
        const columns = [
            {
                name:'ID',
                selector:row => row.id,
                sortable:true
            },
            {
                name:'Kategori',
                selector:row => row.category.name,
                sortable:true
            },
            {
                name:'Şube',
                selector:row => row.branch.name,
            },
            {
                name:'Gider',
                selector:row => row.description
            },
            {
                name:'Tutar',
                selector:row => row.amount

            },

            {
                name: 'İşlem',
                button: true,
                cell: row => (
                    <>

                        {userHasDeleteExpensePermission ? (
                            <IconButton className="btn btn-outline-secondary" onClick={() => this.handleDelete(row.id)} style={{cursor: 'pointer',marginLeft:-15}}>
                                <button type="button" className="btn btn-outline-danger btn-sm" ><i className="icon-trash"></i></button>
                            </IconButton>
                        ):""}
                    </>
                )}

        ]
        return (
            <DataTable
                ref={this.tableRef}
                dataEndpoint={"business/expense/all"}
                columns={columns}
                onRowClicked={userHasViewExpensePermission ? row => this.handleExpenseDetail(row.id) : undefined}
                progressPending={pending}>
            </DataTable>
        )
    }

}
export default withPermissions(withRouter(ExpensesTable));
